import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function MarriageDisclaimer() {

    var [alllowProceed, setalllowProceed] = useState(false);
    var toggleProceedtoForm = () => setalllowProceed(!alllowProceed);

    const triggerForm = () => {
        sessionStorage.setItem('mdc', 1);
        //window.wogaaCustom && window.wogaaCustom.startTransactionalService('ArchivesOnline-2858');
        if (sessionStorage.getItem('mfs')) {
            sessionStorage.removeItem('mfs');
        }
        setTimeout(() => {
            window.location.href = "./marriage/form"
        }, 500);
    }

    return (
        <section id="MarriageDisclaimer">
            <div className="container-fluid mt-3 disclaimer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <img src="./images/icn-OnTopMarriage.png" alt="" />
                                <h2 className="pageTitle mt-2">Marriage Record</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-8 offset-md-2">
                            <div className="card overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex justify-content-center">
                                    <div className="card-content">
                                        <div className="text-center mb-3">
                                            <h3 className="theme-color">Getting Started</h3>
                                        </div>
                                        <div>
                                            <div>
                                                <label className="theme-color">
                                                    <input type="checkbox" onChange={toggleProceedtoForm} />
                                                    <span className="ps-2">I agree for NAS to conduct the search based on the terms below:</span>
                                                </label>
                                            </div>
                                            <ul className="theme-color">
                                                <li>For requests to search for <b>Muslim marriage records</b>, please contact Registry of Muslim Marriages or visit <a className="fw-bold" href="https://www.marriage.gov.sg/muslim/marriage-records/search-marriage-records">here</a></li>
                                                <li>NAS can only conduct a search of marriages that occurred on and prior to 15 September 1961.</li>
                                                <li>
                                                    For requests to search for civil marriage records after 15 September 1961, please contact Registry of Marriages or visit <a className="fw-bold" href="https://www.marriage.gov.sg/civil/marriage-records/search-marriage-records">here</a>
                                                </li>

                                                <li>
                                                    Churches submitted regular returns of solemnized marriages to the Registry of Marriages, so church marriages may also be included in these records.
                                                </li>
                                                <li>
                                                    Customary marriages (e.g. at temples, clan associations) may not be recorded in these registers unless they were subsequently and separately registered with the civil authorities.
                                                </li>
                                                <li>If you still wish for NAS to conduct the search, a non-refundable Request Administration Fee of ${parseFloat(process.env.REACT_APP_ADMINFEE)} (inclusive of {parseInt(process.env.REACT_APP_GST)}% GST) is payable, regardless of whether the marriage record is found.</li>
                                                <li>If an accurate date of marriage is provided, we will provide the findings within 3 working days. NAS will carry out a search for a period of up to only 3 years per request.</li>
                                                <li>For each specific year, we may take up to 7 working days to complete searching the specified year of the marriage.</li>
                                                <li>NAS will provide a letter stating the outcome of the search and a copy of the marriage record (only for a successful marriage record search).</li>
                                            </ul>
                                        </div>
                                        <div className="theme-color text-center">To learn more, click <Link className="fw-bold" to="/marriage/guide">here</Link>.</div>
                                        <div className="text-center mt-3">
                                            {!alllowProceed && <button type="button" disabled={true} className="btn btn-primary me-2">Proceed</button>}
                                            {alllowProceed && <button type="button" onClick={triggerForm} className="btn btn-primary me-2">Proceed</button>}
                                            <Link to={'/'} className="btn btn-secondary">Cancel</Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





